import http from '@/services/http'

export const SET_LIST_TIPOS_PARCELAMENTO = 'setListTiposParcelamento'

export const SET_LIST_TIPOS_PARCELAMENTO_TODOS = 'setListTiposParcelamentoTodos'
export const SET_LIST_PLANILHA = 'setListPlanilha'
export const SET_PLANILHA = 'setPlanilha'
export const SET_TIPO_PARCELAMENTO = 'setTipoParcelamento'
export const SET_TIPOS_PARCELAMENTO_NEW = 'setParcelamentoNew'
export const SET_TIPOS_PARCELAMENTO_UPDATE = 'setParcelamentoUpdate'
export const SET_TIPOS_PARCELAMENTO_DELETE = 'setParcelamentoDelete'
export const SET_MESSAGE_ALERT = 'setMessage'
export const SET_COLUNAS = 'setColunas'

const actions = {

    async listar_tipo_parcelamento(context, value) {
        await http.get('tipo-parcelamento', { params: value })
            .then(response => context.commit(SET_LIST_TIPOS_PARCELAMENTO, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async listar_tipo_parcelamento_todas(context) {
        await http.get('tipo-parcelamento')
            .then(response => context.commit(SET_LIST_TIPOS_PARCELAMENTO_TODOS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async create_tipo_parcelamento(context, value) {
        let message = await http.post('tipo-parcelamento', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_TIPOS_PARCELAMENTO_NEW, message.message.conteudo)
        console.log(message.message)
    },

    async update_tipo_parcelamento(context, value) {
        let data = await http.put('tipo-parcelamento/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
        context.commit(SET_TIPOS_PARCELAMENTO_UPDATE, data.message.conteudo)
    },

    async delete_tipo_parcelamento(context, value) {
        let data = await http.delete('tipo-parcelamento/' + value.id)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
        context.commit(SET_TIPOS_PARCELAMENTO_DELETE, value)
    },
    async listar_colunas(context) {
        await http.get('tipo-parcelamento/colunas')
            .then(response => context.commit(SET_COLUNAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    set_tipo_parcelamento(context, value) {
        context.commit(SET_TIPO_PARCELAMENTO, value)
    },
};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        let customMessage;
        if (typeof value.message === "object") {
            if (value.message.errors) {
                const errors = value.message.errors;
                const errorMessages = [];
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        errorMessages.push(errors[key].join('; '));
                    }
                }
                customMessage = errorMessages.join(' | ');
            } else {
                customMessage = value.message.msg;
            }
        }
        if (value.tipo === 'success' || value.tipo === 'error') {
            state.mensagem_alert = {
                tipo: value.tipo,
                message: customMessage || value.message,
            };
        }
    },
    [SET_LIST_TIPOS_PARCELAMENTO](state, value) {
        state.lista_tipo_parcelamento = value
    },
    [SET_LIST_TIPOS_PARCELAMENTO_TODOS](state, value) {
        state.lista_tipo_parcelamento_todos = value
    }
    ,
    [SET_TIPO_PARCELAMENTO](state, value) {
        state.tipo_parcelamento_tab = value
    },
    [SET_TIPOS_PARCELAMENTO_NEW](state, value) {
        state.lista_tipo_parcelamento.data.push(value)
    },
    [SET_TIPOS_PARCELAMENTO_UPDATE](state, value) {
        state.lista_tipo_parcelamento.data = state.lista_tipo_parcelamento.data.map(i => i.id === value.id ? { ...i, ...value } : i);
    },
    [SET_TIPOS_PARCELAMENTO_DELETE](state, value) {
        state.lista_tipo_parcelamento.data = state.lista_tipo_parcelamento.data.filter(
            (tipo_parcelamento) => tipo_parcelamento.id !== value.id
        );
    },


};
const getters = {}

const state = {
    mensagem_alert: [],
    lista_tipo_parcelamento:   { data: [], pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0
    } },
    tipo_parcelamento: [],
    lista_tipo_parcelamento_todos: []
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
